import React from 'react';
import { Breadcrumb } from 'react-bootstrap';

interface PathNavigatorProps {
    path: { id: string | number; name: string }[];
    onClick: any;
}

export const PathNavigator: React.FC<PathNavigatorProps> = ({ path, onClick }) => {
    return (
        <Breadcrumb>
            {path.map((e) => (
                <Breadcrumb.Item
                    key={e.id}
                    as="div"
                    style={{
                        cursor: 'pointer',
                        color: '#007bff',
                    }}
                    linkAs="div"
                    onClick={() => {
                        onClick({ id: e.id, isCategory: true });
                    }}
                >
                    {e.name}
                </Breadcrumb.Item>
            ))}
        </Breadcrumb>
    );
};
